import React, { useEffect, useState } from "react";
import { HashRouter, Routes, Route } from "react-router";

import League from "./pages/league";
import Team from "./pages/team";
import Stocks from "./pages/stocks";

import "./App.css";

function App() {
  const [data, setData] = useState(null);

  //Read in dataset with team/stock details.
  useEffect(() => {
    fetch("/data.json")
      .then((response) => response.json())
      .then((data) => setData(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <HashRouter basename="/">
      <Routes>
        <Route path="/" element={<League data={data} />} />
        <Route path="/team/:id" element={<Team data={data} />} />
        <Route path="/stocks" element={<Stocks data={data} />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
